export function routerBasename(): string | undefined {
  const raw = (import.meta.env.BASE_URL || '/').trim();
  if (!raw || raw === '/') return undefined;
  const normalized = raw.endsWith('/') ? raw.slice(0, -1) : raw;
  return normalized || undefined;
}

export function buildAppRoute(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const base = routerBasename();
  if (!base) return normalizedPath;
  if (normalizedPath === '/') return `${base}/`;
  return `${base}${normalizedPath}`;
}
